import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { withFormik, Field, Form, getIn } from 'formik';
import * as Yup from 'yup';

import '../../../services/yupCustomMethods';
import { FormikInput, FormikSwitch, FormikNumberFormat } from '../../../components';
import { lowerCaseTextFormat, percentageLimit, rutFormat, validRutInput } from '../../../services/utils';
import ExecutiveManagerRemoteSelector from '../../../components/Shared/ExecutiveManagerRemoteSelector';

const AdminCompanyForm = ({ action, errors, onHide, submitVariant, touched, setFieldValue }) => {
  const handleNationalIdentificationFormat = e => {
    if (validRutInput(e)) {
      const formattedValue = rutFormat(e.target.value);
      setFieldValue(e.target.name, formattedValue);
    }
  };

  const handleFormatTextToLowerCase = e => {
    const formattedValue = lowerCaseTextFormat(e.target.value);
    setFieldValue(e.target.name, formattedValue);
  };

  const submitBtnText = action === 'new' ? 'Crear Empresa' : 'Guardar Cambios';

  return (
    <Form>
      <Row>
        <Col md={8}>
          <Field name="company[active]">
            {({ field }) => <FormikSwitch {...field} abbr field={field} label="¿Empresa activa?" />}
          </Field>
        </Col>
        <Col md={4}>
          <Field name="company[executiveManagerId]">
            {({ field }) => <ExecutiveManagerRemoteSelector fromAdmin field={field} modelName="company" />}
          </Field>
        </Col>
        <Col md={6} sm={12}>
          <Field name="company[name]">
            {({ field }) => (
              <FormikInput
                {...field}
                abbr
                label="Nombre"
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col md={6} sm={12}>
          <Field name="company[nationalIdentification]">
            {({ field }) => (
              <FormikInput
                {...field}
                abbr
                label="RUT empresa"
                onChange={handleNationalIdentificationFormat}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col md={6} sm={12}>
          <Field name="company[email]">
            {({ field }) => (
              <FormikInput
                {...field}
                abbr
                label="Correo electrónico"
                onChange={handleFormatTextToLowerCase}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col md={6} sm={12}>
          <Field name="company[parsedNicoCommissionPercentage]">
            {({ field }) => (
              <FormikNumberFormat
                {...field}
                abbr
                label="% Comisión NICO"
                suffix=" %"
                isAllowed={percentageLimit}
                fieldName="company[nicoCommissionPercentage]"
                error={getIn(errors, 'company[nicoCommissionPercentage]')}
                touched={getIn(touched, 'company[nicoCommissionPercentage]')}
              />
            )}
          </Field>
        </Col>
      </Row>

      <p className="section-subtitle">Marcas de empresa</p>
      <Row className="mb-5">
        <Col xs={6} md={2}>
          <Field name="company[isNotifiedInsuredUser]">
            {({ field }) => <FormikSwitch {...field} field={field} label="Cobranza a cliente" />}
          </Field>
        </Col>
      </Row>

      <Row className="d-flex justify-content-end">
        <Col md={3} sm={12} className="my-5">
          <Button type="submit" variant={submitVariant} size="lg" onClick={onHide} className="w-100">
            {submitBtnText}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

const setInitialValues = ({ company }) => {
  const { nationalIdentification } = company;
  return {
    company: {
      ...company,
      nationalIdentification: rutFormat(nationalIdentification)
    }
  };
};

const validationSchema = Yup.object().shape({
  company: Yup.object().shape({
    email: Yup.string()
      .required('Debes ingresar un correo electrónico')
      .email('Debes ingresar un correo electrónico válido'),
    executiveManagerId: Yup.string().required('Debes seleccionar un ejecutivo'),
    name: Yup.string().required('Debes ingresar un nombre'),
    nationalIdentification: Yup.string()
      .required('Debes ingresar un RUT')
      .rut('El RUT es inválido'),
    nicoCommissionPercentage: Yup.string()
      .required('Debes ingresar un porcentaje para la comisión')
      .typeError('Debes ingresar un porcentaje para la comisión')
  })
});

const handleSubmit = (values, { props }) => {
  const { formRequest, onHide } = props;
  formRequest(values);
  if (onHide) onHide();
};

export default withFormik({
  mapPropsToValues: setInitialValues,
  handleSubmit,
  validationSchema,
  enableReinitialize: true,
  validateOnMount: props => props.action !== 'new'
})(AdminCompanyForm);
